var _path, _path2, _path3, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5002 27.6668C11.1445 27.6668 11.6668 27.1445 11.6668 26.5002C11.6668 25.8558 11.1445 25.3335 10.5002 25.3335C9.85583 25.3335 9.3335 25.8558 9.3335 26.5002C9.3335 27.1445 9.85583 27.6668 10.5002 27.6668Z",
    stroke: "#135478",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3332 27.6668C23.9775 27.6668 24.4998 27.1445 24.4998 26.5002C24.4998 25.8558 23.9775 25.3335 23.3332 25.3335C22.6888 25.3335 22.1665 25.8558 22.1665 26.5002C22.1665 27.1445 22.6888 27.6668 23.3332 27.6668Z",
    stroke: "#135478",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1665 3.1665H5.83317L8.95984 18.7882C9.06652 19.3253 9.35873 19.8078 9.78531 20.1512C10.2119 20.4946 10.7457 20.677 11.2932 20.6665H22.6332C23.1807 20.677 23.7145 20.4946 24.141 20.1512C24.5676 19.8078 24.8598 19.3253 24.9665 18.7882L26.8332 8.99984H6.99984",
    stroke: "#135478",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 7.5,
    r: 7.5,
    fill: "#135478"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.96b53da2144d655179f4400e8668c179.svg";
export { ForwardRef as ReactComponent };